export enum makeRequestTypes {
    technical = 'Technique',
    administrative = 'Administratif'
}

export const categoryEnum = {
    technical: {
        private: 'Parties privatives',
        common: 'Partives Communes',
        sinisters: 'Sinistres'
    },
    administrative: {
        bill: 'Règlement et Facturation',
        neighbor: 'Vie de la résidence et du voisinage',
        contract: 'Vie du contrat',
        deposit: 'Résiliation du bail',
        debit: 'Prélèvement automatique',
        assurance: 'Attestation d\'assurance habitation'
    }
}

export const subCategoryEnum = {
    private: {
        heater: 'private_heater',
        electricity: 'private_electricity',
        ventilation: 'private_ventilation',
        joinery: 'private_joinery',
        plumbing: 'private_plumbing',
        hotWater: 'private_hotWater',
        waterInfiltration: 'private_waterInfiltration',
        disinfection: 'private_disinfection',
        authorization: 'private_authorization',
        gaz: 'private_gaz',
        shutter: 'private_shutter',
        electrical: 'private_electrical',
        miscellaneous: 'private_miscellaneous',
        entree: "private_entree",
        serruresbarillets: "private_serruresbarillets",
        clesbadges: "private_clesbadges",
        electriciteeclairage: "private_electriciteeclairage",
        detecteurfumee: "private_detecteurfumee",
        fenetresencadrements: "private_fenetresencadrements",
        voletsbasse: "private_voletsbasse",
        voletshaute: "private_voletshaute",
        vitrage: "private_vitrage",
        convecteursradiateurs: "private_convecteursradiateurs",
        mursinterieurs: "private_mursinterieurs",
        parquets: "private_parquets",
        moquetterevetements: "private_moquetterevetements",
        aerationventilation: "private_aerationventilation",
        vmc: "private_vmc",
        arriveegaz: "private_arriveegaz",
        flexiblegaz: "private_flexiblegaz",
        flexiblegrillesiphon: "private_flexiblegrillesiphon",
        colonneeaux: "private_colonneeaux",
        canalisationseauusees: "private_canalisationseauusees",
        abattantswc: "private_abattantswc",
        canalisationeau: "private_canalisationeau",
        douchetteflexibledouche: "private_douchetteflexibledouche",
        carrelagefaience: "private_carrelagefaience",
        robinetterie: "private_robinetterie",
        chasseeau: "private_chasseeau",
        evierslavabosbaignoiressanitaires: "private_evierslavabosbaignoiressanitaires",
        chaudieremuraleballonelectrique: "private_chaudieremuraleballonelectrique",
        cave: "private_cave",
        boxstationnement: "private_boxstationnement",
        terrassebalcon: "private_terrassebalcon",
        divers: "private_divers",
        electromenager: "private_electromenager",
        equipementsconfort: "private_equipementsconfort",
    },
    common: {
        elevator: 'common_elevator',
        door: 'common_door',
        light: 'common_light',
        maintenance: 'common_maintenance',
        technicalLocal: 'common_technicalLocal',
        letters: 'common_letters',
        security: 'common_security',
        optic: 'common_optic',
        renovation: 'common_renovation',
        disinfection: 'common_disinfection',
        deliveryBox: 'common_deliveryBox',
        sharedLib: 'common_sharedLib',
        plumbingCommon: 'common_plumbingCommon'
    },
    sinisters: {
        waterDamages: 'sinisters_waterDamages',
        fire: 'sinisters_fire',
        brokenGlass: 'sinisters_brokenGlasses'
    },
    bill: {
        rent: 'bill_rent',
        rentalCharge: 'bill_rentalCharge',
        debit: 'bill_debit',
        paymentNotCashed: 'bill_paymentNotCashed',
        contestBill: 'bill_contestBill',
        miscellaneous: 'bill_miscellaneous'
    },
    neighbor: {
        parking: 'neighbor_parking',
        clutter: 'neighbor_clutter',
        trade: 'neighbor_trade',
        smell: 'neighbor_smell',
        sound: 'neighbor_sound',
        sharedLib: 'neighbor_sharedLib'
    },
    contract: {
        requestParking: 'contract_requestParking',
        requestHome: 'contract_requestHome',
        occupantsModification: 'contract_occupantsModification',
        transferDocuments: 'contract_transferDocuments',
        renewLease: 'contract_renewLease',
        key: 'contract_key',
        miscellaneous: 'contract_miscellaneous'
    }
}

export const othersEnum = {
    private: ['waterInfiltration', 'disinfection', 'authorization', 'gaz', 'shutter', 'electrical', 'miscellaneous'],
    common: ['letters', 'security', 'optic', 'renovation', 'disinfection', 'deliveryBox', 'sharedLib'],
    sinister: [],
    bill: ['paymentNotCashed', 'contestBill', 'miscellaneous'],
    neighbor: [],
    contract: ['key', 'miscellaneous']
}

export const directionMessage = {
    entrant: '221310000',
    sortant: '221310001'
}
/**
 * Fonction qui retourne la key de l'id référencé ainsi que son noeud parent
 * @param subcategoryId
 */
export const getInfoForSubcategoryId = (subcategoryId: string) => {
    const parentKey = Object.keys(subCategoryEnum)
        .find((subKey: string) => {
            return Object.values(subCategoryEnum[subKey as keyof typeof subCategoryEnum])
                .find(val => val === subcategoryId)
        }) as keyof typeof subCategoryEnum

    if (parentKey && subCategoryEnum[parentKey]) {
        const subCategory = subCategoryEnum[parentKey]
        const valueKey = Object.keys(subCategory).find((key: string) => subCategory[key as keyof typeof subCategory] === subcategoryId)

        return { parentKey, valueKey }
    }

    return { parentKey: null, valueKey: null }
}

/**
 * Récupération de la clé parent pour une catégorie donnée
 * @param categoryKey
 */
export const getInfoForCategoryKey = (categoryKey: string) => {
    const parentKey = Object.keys(categoryEnum)
        .find((catKey: string) => {
            return Object.keys(categoryEnum[catKey as keyof typeof categoryEnum]).find((key: string) => key === categoryKey)
        }) as keyof typeof categoryEnum

    const category = categoryEnum[parentKey]
    const valueLabel = category[categoryKey as keyof typeof category]

    return { parentKey, valueLabel }
}
